import React, { useState } from 'react';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import { Box, IconButton } from '@mui/material';

import Modal from 'src/components/common/Modal';

import { styles } from './index.styles';

const ButtonModal = ({
  headline,
  text,
}: {
  headline: string;
  text: string;
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Box data-test-id="help-button" sx={styles.buttonHelperModal}>
      <IconButton size="small" onClick={() => setShowModal(true)}>
        <HelpRoundedIcon color="primary" />
      </IconButton>
      <Modal
        headline={headline}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      >
        <p>{text}</p>
      </Modal>
    </Box>
  );
};

export default ButtonModal;
